import i18n from "Shared/locales/i18n"

export const ChangeHistoryRules = () => ({
    resource: [{ required: true, message: i18n.t("validation:required") }],
    changeHistoryPeriod: [{ required: true, message: i18n.t("validation:required") }],
})
